module.exports = __webpack_public_path__ + "static/media/person.7d2f54df.svg";